import React, { useEffect, useState } from "react";
import {
  KeyboardAvoidingView,
  View,
  FlatList,
  Text,
  StyleSheet,
  Platform,
} from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import Header from "../../common/header/index";

import Utils, { escapeRegexp, hasItems } from "../../../../helpers/utils";
import ReportsFabButton from "../ReportsFabButton";
import Search from "../../common/search-bar/Search";
import ReportUser from "./ReportUser";
import RoundCheckbox from "../../common/RoundCheckbox";
import UsersHelper from "../../users/UsersHelper";

export default function RecipientsList({
  goBack,
  controller,
  reportRecipients = [],
}) {
  const [userList, setUserList] = useState([]);
  const [allUserList, setAllUserList] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [hasSelectedChildren, setSelectedChildren] = useState(false);

  useEffect(() => {
    const users = UsersHelper.getManagers(controller);

    if (hasItems(reportRecipients)) {
      users.forEach((u) => {
        u.isSelected = reportRecipients.includes(u.email);
      });
    } else {
      users.forEach((u) => {
        u.isSelected = true;
      });
    }

    setUserList(users);
    setAllUserList(users);
  }, []);

  useEffect(() => {
    const selected = userList.filter((u) => u.isSelected).length;
    if (selected == userList.length) {
      setAllSelected(true);
      setSelectedChildren(false);
    } else if (selected > 0) {
      setSelectedChildren(true);
    } else {
      setAllSelected(false);
      setSelectedChildren(false);
    }
  }, [userList]);

  const toggleSelection = (user) => {
    userList.forEach((u) => {
      u.isSelected = u.email == user.email ? !u.isSelected : u.isSelected;
    });

    setUserList([...userList]);
  };

  const toggleAllSelection = (isSelected) => {
    userList.forEach((u) => {
      u.isSelected = isSelected;
    });

    setUserList([...userList]);
  };

  const filterResults = ({ term }) => {
    let filtered = [...allUserList];

    if (term) {
      const pattern = Utils.getSearchPattern(term);

      filtered = filtered.filter((a) => {
        return a.name && a.name.match(pattern);
      });
    }

    setUserList(filtered);
  };

  const onGoBack = () => {
    const selected = userList.filter((u) => u.isSelected);
    goBack(selected);
  };

  return (
    <View style={appStyles.container}>
      <KeyboardAvoidingView style={appStyles.kbViewNoFooter} behavior="height">
        <Header
          title="Filter by Person"
          subTitle="Choose whose reports to see"
          goBack={onGoBack}
        />

        <View style={appStyles.preList} />
        {/* All */}
        <View style={styles.all}>
          <Text style={styles.allLabel}>All</Text>
          <RoundCheckbox
            size={16}
            checked={allSelected}
            hasChildrenChecked={hasSelectedChildren}
            onValueChange={(value) => toggleAllSelection(value)}
          />
        </View>

        <FlatList
          contentContainerStyle={{ paddingBottom: 100 }}
          style={[
            appStyles.scrollView,
            {
              paddingHorizontal: 8,
              marginTop: 0,
            },
          ]}
          data={userList}
          keyExtractor={(user) => user.email}
          renderItem={({ item }) => (
            <ReportUser user={item} toggleSelection={toggleSelection} />
          )}
        />

        <View style={[appStyles.footerOptions]}>
          <ReportsFabButton style={{ bottom: 80 }} />

          <Search
            showIcon={false}
            placeholder="Search recipients"
            filterResults={filterResults}
            style={{ marginBottom: 14 }}
            controller={controller}
          />
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}

const styles = StyleSheet.create({
  all: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    marginHorizontal: 8,
    paddingLeft: 16,
    borderBottomWidth: 1,
    borderBottomColor: AppTheme.borderColor,
  },
  allLabel: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
});
